export default "__VITE_ASSET__CVeFgq8R__"